import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import api from "./api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    try { return JSON.parse(localStorage.getItem("hc_user") || "null"); }
    catch { return null; }
  });
  const [token, setToken] = useState(() => localStorage.getItem("hc_token"));
  const [loading, setLoading] = useState(false);

  const persist = (t, u) => {
    localStorage.setItem("hc_token", t);
    localStorage.setItem("hc_user", JSON.stringify(u));
    setToken(t);
    setUser(u);
  };

  const login = async (email, password) => {
    const { data } = await api.post("/patient-auth/login", { email, password });
    persist(data.token, data.user);
    return data.user;
  };

  const register = async (payload) => {
    const { data } = await api.post("/patient-auth/register", payload);
    persist(data.token, data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("hc_token");
    localStorage.removeItem("hc_user");
    setToken(null);
    setUser(null);
  };

  const refreshMe = useCallback(async () => {
    if (!token) return;
    try {
      const { data } = await api.get("/patient-auth/me");
      setUser(data);
      localStorage.setItem("hc_user", JSON.stringify(data));
    } catch { /* handled by interceptor */ }
  }, [token]);

  useEffect(() => { if (token && !user) refreshMe(); }, [token, user, refreshMe]);

  return (
    <AuthContext.Provider value={{ user, token, loading, login, register, logout, refreshMe, setUser }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
